(ns storrito.editor.sticker-util
  (:require [garden.color :as gc]
            [clojure.string :as str]))

;; Concept
;;
;; Util functions to display Instagram stickers in the Storrito editor.

(defn darken
  "Combines garden functions to create a darker version of a hex-color string."
  [hex-color amount]
  (-> hex-color
      (gc/hex->rgb)
      (gc/darken amount)
      (gc/as-hex)))

(defn lighten
  "Combines garden functions to create a lighter version of a hex-color string."
  [hex-color amount]
  (-> hex-color
      (gc/hex->rgb)
      (gc/lighten amount)
      (gc/as-hex)))

(defn shadow-color
  "Creates either a darker or a lighter hex-color string for Instagram stickers."
  [background-color]
  (let [bg-lightness (:lightness (gc/as-hsl (gc/hex->rgb background-color)))]
    (if (>= bg-lightness 25)
      (darken background-color 12)
      (lighten background-color 12))))

(defn wrap-and-trim
  "Wraps and trims a string to a certain line length to be displayed in fabricjs textfields."
  [text max-length]
  (str/join "\n" (map
                   (fn [chars]
                     (apply str chars))
                   (partition-all max-length text))))

(defn convert-color-stops
  "Converts the Color stops from fabricjs 2.3.4 to 4.3.1"
  [color-stops]
  (clj->js (into []
                 (map
                   (fn [[k v]]
                     {:offset k :color v})
                   color-stops))))
